export default __webpack_public_path__ + "static/ambient-ai-dark-d2680746413b0045728e65ec82cf2958b9098fd2f6fc25e7533de8818966ddc2.png";